import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar
} from '@ionic/react'
import { arrowBack } from 'ionicons/icons'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import Form from '../../components/form/Form'
import ProspectoButton from '../../components/ProspectoButton'
import { useAppContext } from '../../context/AppContext'
import useFormFields from '../../hooks/useFormFields'
import { newProspectoCompleted } from '../../redux/actions'

const NuevoProspecto = () => {
  const history = useHistory()
  const storeForm = 'nuevoProspectoForm'
  const dispatch = useDispatch()
  const { setBlockNavigation }: any = useAppContext()

  const { nuevoProspectoFields } = useFormFields()

  const leavePage = () => {
    dispatch(newProspectoCompleted())
    history.push('/procedures/referidos')
    setBlockNavigation(false)
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={leavePage}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Nuevo Referido</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid className="grid-col min-height-calc ion-justify-content-between ion-align-items-center">
          <IonRow className="ion-justify-content-center ion-padding width-100 max-width-500">
            <IonCol>
              <IonRow className="ion-margin-bottom ion-justify-content-center nuevo-prospecto-header">
                Completá los datos del cliente
              </IonRow>
              <Form fields={nuevoProspectoFields} storeForm={storeForm} inputsPosition="floating" />
            </IonCol>
          </IonRow>
          <IonRow class="padding-down">
            <ProspectoButton storeForm={storeForm} label="Guardar" />
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  )
}

export default NuevoProspecto
